<div class="mb-20">
  @for (product of products; track product.productId) {
    <section
      #productRef
      id="{{ 'prod' + product.productId }}"
      class="w-10/12 mx-auto mb-12 sm:w-9/12 p-7 sm:p-14"
    >
      @if (product.productId % 2 === 0) {
        <div class="flex">
          <div class="hidden lg:flex relative items-center w-3/5">
            <img
              src="assets/img/Products/{{ product.productImage }}"
              alt="Product"
              class="absolute right-20 pygImg"
            />
          </div>
          <div class="lg:w-3/5">
            <h3>{{ product.productName | translate }}</h3>
            <div class="lg:hidden w-11/12 mx-auto mt-5 sm:mx-0">
              <img
                src="assets/img/Products/{{ product.productImage }}"
                alt="Product"
              />
            </div>
            <h6 class="pt-5 uppercase">
              {{ "products_page.keyUseCases" | translate }}
            </h6>
            <p class="">{{ product.productUseCases | translate }}</p>
            <h6 class="pt-5 uppercase">
              {{ "products_page.keyReports" | translate }}
            </h6>
            <p class="">{{ product.productReports | translate }}</p>
            <h6 class="pt-5 uppercase">
              {{ "products_page.howItWorks" | translate }}
            </h6>
            <p class="mb-5">{{ product.productHowWorks | translate }}</p>
            <app-get-demo></app-get-demo>
          </div>
        </div>
      }
      @if (product.productId % 2 === 1) {
        <div class="flex">
          <div class="lg:w-3/5">
            <h3>{{ product.productName | translate }}</h3>
            <div class="lg:hidden w-11/12 mx-auto mt-5 sm:mx-0">
              <img
                src="assets/img/Products/{{ product.productImage }}"
                alt="Product"
              />
            </div>
            <h6 class="pt-5 uppercase">
              {{ "products_page.keyUseCases" | translate }}
            </h6>
            <p class="">{{ product.productUseCases | translate }}</p>
            <h6 class="pt-5 uppercase">
              {{ "products_page.keyReports" | translate }}
            </h6>
            <p class="">{{ product.productReports | translate }}</p>
            <h6 class="pt-5 uppercase">
              {{ "products_page.howItWorks" | translate }}
            </h6>
            <p class="mb-5">{{ product.productHowWorks | translate }}</p>
            <app-get-demo></app-get-demo>
          </div>
          <div class="hidden lg:flex relative items-center w-3/5">
            <img
              src="assets/img/Products/{{ product.productImage }}"
              alt="Product"
              class="absolute left-20"
            />
          </div>
        </div>
      }
    </section>
  }
</div>
